import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import { BASE_URL } from '../../api/api'
import NavLink from '../navLink'

const Yjbg = ({ reportList = {} }) => (
  <div className="w-full bg-[#f9f9f9] mt-[60px] px-5 lg:px-0 pb-10 lg:pb-[60px]">
    <div className="max-w-1200 mx-auto pt-[41px]">
      <div className="flex justify-center lg:justify-between items-center">
        <p></p>
        <H2Title title="研究报告" />
        <GenDuo href={`/yjbg/channel_id/${reportList?.channel?.id}`} className="hidden lg:block" />
      </div>
      <div className="flex justify-between flex-wrap">
        {reportList?.list?.map(({ id, title, image = '', description, job, outlink }, key) => (
          <NavLink isOutLink={!!outlink} to={outlink || `/wzxq/id/${id}`} key={id}>
            <div key={key} className="w-[160px] gap-2 lg:w-[280px] mt-9 p-2 bg-white">
              <img src={`${BASE_URL}${image}`} width="100%" style={{ height: 154 }} alt="" />
              <p className="mt-2 lg:mt-4 text-[#333] text-xl font-bold">{title}</p>
              <p className="mt-2 lg:mt-4 text-[#333]">{job}</p>
              <p className="mt-2 lg:mt-4 text-sm text-[#555555] font-sourceHan leading-[28px] text-ellipsis overflow-hidden max-h-[80px]">
                {description}
              </p>
            </div>
          </NavLink>
        ))}
        <div className="hidden lg:block lg:w-[280px]" />
        <div className="hidden lg:block lg:w-[280px]" />
      </div>
      <div className="flex lg:hidden justify-center flex-col">
        <GenDuo
          href={`/yjbg/channel_id/${reportList?.channel?.id}`}
          color="#0189D5"
          className="mx-auto mt-[30px] bg-white px-6 py-2 rounded-xl "
        />
      </div>
    </div>
  </div>
)

export default Yjbg
